import { Injectable } from '@angular/core';
import { CONFIGURATION } from "../app.config";
import { Observable } from "rxjs/Observable";
import { Http, Response, Headers, RequestOptions } from "@angular/http";

@Injectable()
export class SetpasswordService {

  private _AuthUrl = CONFIGURATION.baseAuthURL;

  constructor(private _http: Http) { }

  setpassword(newvalues: any): Observable<any> {
    const headers = new Headers();
    const options = new RequestOptions({ headers: headers });
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._AuthUrl + '/set-password', newvalues, { headers: headers })
    .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  postOtp(newvalues: any): Observable<any> {
    const headers = new Headers();
    const options = new RequestOptions({ headers: headers });
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._AuthUrl + '/validate-set-password-otp', newvalues, { headers: headers })
    .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  private handleError(error: Response) {
 
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/setpassword/setpassword.component.service.ts